import {inject, Injectable} from '@angular/core';
import {hypothesisResourceType} from "../configs/hypothesis-modal-config";
import {HypothesisFilesColumns, HypothesisModalDialogData} from "../types/hypothesis-modal.types";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class HypothesisModalService {
  private router: Router = inject(Router);

  public setTextDialogData(hypothesisDialogData: HypothesisModalDialogData, column: HypothesisFilesColumns) {
    return {
      path: hypothesisResourceType.path,
      modalName: `Текст ${column.title}`,
      recordId: hypothesisDialogData.id,
      key: column.inputName,
      fieldLabel: 'Комментарий',
      content: hypothesisDialogData[column.inputName]
    };
  }

  public async setUrlQueryParams(hypothesisId: number): Promise<void> {
    await this.router.navigate([], {
      queryParams: { hypothesisModal: hypothesisId},
      queryParamsHandling: 'merge',
    });
  }

  public async resetUrlQueryParams(): Promise<void> {
    await this.router.navigate([], {
      queryParams: {},
      queryParamsHandling: '',
      replaceUrl: true
    });
  }
}
